<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Custom Field</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">
    <div class="form-group">
      <label for="typeSelect">Type</label>
      <div ngbTooltip="May not be changed for an existing custom field.">
        <select id="typeSelect" name="field_type" class="custom-select disabled"
                [(ngModel)]="field.field_type"
                disabled>
          <option [ngValue]="CustomCustomerFieldType.checkboxes">Checkboxes</option>
          <option [ngValue]="CustomCustomerFieldType.dropdown">Dropdown</option>
          <option [ngValue]="CustomCustomerFieldType.radio">Radio Buttons</option>
          <option [ngValue]="CustomCustomerFieldType.singleLineText">Single-Line Text</option>
          <option [ngValue]="CustomCustomerFieldType.multipleLineText">Multiple-Line Text</option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label for="nameInput">
        Name
      </label>
      <input id="nameInput" type="text" class="form-control" name="name"
             required ngbAutofocus
             [(ngModel)]="field.name">
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>

    <!--suppress TypeScriptValidateTypes -->
    <div class="form-group"
         *ngIf="![CustomCustomerFieldType.singleLineText, CustomCustomerFieldType.multipleLineText].includes(field.field_type)">
      <label>Options</label>
      <div class="input-group mb-1" *ngFor="let option of field.options; trackBy:trackByIdx; index as idx;">
        <input type="text" class="form-control" name="option{{ idx }}"
               maxlength="127"
               (keydown.enter)="$event.preventDefault();"
               [(ngModel)]="field.options[idx]">
        <div class="input-group-append">
          <button class="btn btn-outline-danger" type="button"
                  (click)="field.options.splice(idx, 1)">
            Remove
          </button>
        </div>
      </div>
      <button class="btn btn-block btn-outline-success" type="button"
              (click)="field.options.push('')">
        Add Option
      </button>
      <div class="form-text text-danger">{{ errors.options }}</div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
